import { ContentTypeEnum } from '../../../shared/types'
import { Loading } from '../../common'
import { CopyContainer } from '../../common/copy'
import { BodyContent } from '../../content'
import DebugJson from '../../debug/DebugJson/DebugJson'
import useDashScene from './useDashScene'

const DashScene = () => {
  const { scene, content, actions, loading, error } = useDashScene()
  const { filePath, parentMeta } = content || {}

  return (
    <Loading loading={loading} fullscreen message="Loading Dash Scene...">
      {scene?.body?.content && (
        <BodyContent
          parentMeta={parentMeta}
          filePath={filePath}
          contentBlock={scene?.body}
          copyContainerStyles={{
            padding: 'xlarge',
            noRightMargin: true,
          }}
        />
      )}

      <DebugJson json={scene} />
    </Loading>
  )
}

export default DashScene
